import { z } from "zod";

//#region src/tools/catalog-runtime/schema.ts
const UNION_KEYWORDS = [
	"anyOf",
	"oneOf",
	"allOf"
];
function zodFieldMapToJsonSchema(fieldMap) {
	const zodObject = Object.keys(fieldMap).length > 0 ? z.object(fieldMap) : z.object({});
	const { $schema: _,...jsonSchema } = z.toJSONSchema(zodObject, {
		io: "input",
		target: "draft-7",
		unrepresentable: "any"
	});
	return jsonSchema;
}
/**
* Find JSON Schema union shapes that known model APIs reject for tool schemas.
*
* Banned:
* - root-level `anyOf` / `oneOf` / `allOf` (Anthropic rejects these)
* - nested unions inside another union (for example union + nullable)
*
* Allowed:
* - property-level flat unions such as `string | null` or `string | string[]`
*/
function findIncompatibleJsonSchemaUnions(schema, path = [], insideUnion = false) {
	if (!schema || typeof schema !== "object") return [];
	if (Array.isArray(schema)) return schema.flatMap((item, index) => findIncompatibleJsonSchemaUnions(item, path.concat(String(index)), insideUnion));
	const record = schema;
	const violations = [];
	const atRoot = path.length === 0;
	for (const keyword of UNION_KEYWORDS) {
		const branches = record[keyword];
		if (!Array.isArray(branches)) continue;
		const nextPath = path.concat(keyword);
		const pathLabel = nextPath.join(".");
		if (atRoot) violations.push({
			path: pathLabel,
			reason: "root-union",
			keyword
		});
		else if (insideUnion) violations.push({
			path: pathLabel,
			reason: "nested-union",
			keyword
		});
		violations.push(...findIncompatibleJsonSchemaUnions(branches, nextPath, true));
	}
	for (const [key, value] of Object.entries(record)) {
		if (UNION_KEYWORDS.includes(key)) continue;
		violations.push(...findIncompatibleJsonSchemaUnions(value, path.concat(key), insideUnion));
	}
	return violations;
}
function formatJsonSchemaUnionViolations(violations) {
	return violations.map((violation) => `${violation.path} (${violation.reason})`).join(", ");
}

//#endregion
export { findIncompatibleJsonSchemaUnions, formatJsonSchemaUnionViolations, zodFieldMapToJsonSchema };
//# sourceMappingURL=schema-BuKqZlvC.js.map